import AppLayout from "components/Layout/AppLayout";
import React, { useEffect, useState } from "react";
import { ReactComponent as ProfileIcon } from "assets/icons/profile.svg";
import { ReactComponent as FAQIcon } from "assets/icons/faq.svg";
import { ReactComponent as TermsOfServiceIcon } from "assets/icons/terms_of_service.svg";
import { ReactComponent as ArrowRightIcon } from "assets/icons/arrow_right.svg";
import { ReactComponent as ArrowBottom } from "assets/icons/arrow_bottom.svg";
import { ReactComponent as ShareIcon } from "assets/icons/share.svg";
import { ReactComponent as BillingIcon } from "assets/icons/credit_card.svg";
import FAQ from "./components/FAQ";
import Profile from "./components/Profile";
import FilterDropdown from "pages/Research/components/FilterDropdown";
import useSearchFilter from "hooks/useSearchFilter";
import useSubscription from "hooks/useSubscription";
import { useLocation } from "react-router";
import Prices from "./components/Prices";

const manuList = [
  {
    id: 1,
    Icon: ProfileIcon,
    title: "Profilo",
    subtitle: "Immagine, Nome, Email e Password",
    LastIcon: ArrowRightIcon,
  },
  {
    id: 2,
    Icon: FAQIcon,
    title: "FAQ e Assistenza",
    subtitle: "Domande Frequenti e Aiuto",
    LastIcon: ArrowRightIcon,
  },
  {
    id: 3,
    Icon: TermsOfServiceIcon,
    title: "Termini Del Servizio",
    subtitle: "Termini e Condizioni, Privacy e GDPR",
    LastIcon: ShareIcon,
  },
  {
    id: 4,
    Icon: FAQIcon,
    title: "Prezzi",
    subtitle: "Sblocca la potenza del piano PRO",
    LastIcon: ArrowRightIcon,
  },
  {
    id: 5,
    Icon: BillingIcon,
    title: "Gestione Fatturazione",
    subtitle: "Gestisci abbonamento, pagamenti e fatturazione",
    LastIcon: ArrowRightIcon,
  },
];

const Settings = () => {
  const [selectedComponent, setSelectedComponent] = useState(1);
  const { toggleFilterDropdown } = useSearchFilter();
  const location = useLocation();
  const { manageSubscription, loading, subscriptionStatus } = useSubscription();

  const handleMenuClick = async (id, dropdownId) => {
    if (id === 5) {
      // If user has an active premium subscription, redirect to billing portal
      if (subscriptionStatus.hasPremium) {
        try {
          await manageSubscription(window.location.href);
          setSelectedComponent(id);
        } catch (error) {
          console.error("Error accessing billing portal:", error);
        }
        return;
      }

      if (dropdownId) {
        toggleFilterDropdown(dropdownId);
      }
      return;
    }

    setSelectedComponent(id);
    if (dropdownId) {
      toggleFilterDropdown(dropdownId);
    }

    if (id === 3) {
      window.open("https://www.iubenda.com/privacy-policy/97520177", "_blank");
    }
  };

  // Scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const filteredMenuList = manuList.filter((item) => {
    if (item.id === 5) {
      // Hide billing portal for trial users - only show for users with actual paid subscriptions
      return subscriptionStatus.hasPremium && !subscriptionStatus.isInTrial;
    }
    return true;
  });

  return (
    <AppLayout isSearchVisable={true}>
      <div className="bg-[#F5F5F5] h-auto pb-[100px] min-h-[calc(100vh-88px)] pt-[17px] md:pt-[41px] px-[24px] md:px-[48px] md:pb-[20px]">
        {/* mobile tab  */}
        <div className="block xl:hidden mb-[18px] w-full relative">
          <FilterDropdown
            id="settings"
            buttonStyle={{
              backgroundColor: "#F8F8FF",
              border: "0.68px solid #E2E4E9",
              height: 40,
              paddingLeft: 23,
              paddingRight: 23,
            }}
            dropdownStyle={{ width: "100%", left: 0, top: 40 }}
            buttonTextStyle={{
              color: "#615E83",
              fontWeight: 400,
              fontSize: 16,
            }}
            selectedItem={
              filteredMenuList.find((item) => item.id === selectedComponent)
                ?.title
            }
          >
            <div className="">
              <p
                onClick={() => handleMenuClick(1, "settings")}
                className="text-[#615E83] font-normal text-[16px] leading-[50px] cursor-pointer px-[23px] hover:bg-slate-50 transition-all duration-200 ease-in"
              >
                Profilo
              </p>
              <p
                onClick={() => handleMenuClick(2, "settings")}
                className="text-[#615E83] font-normal text-[16px] leading-[50px] cursor-pointer px-[23px] hover:bg-slate-50 transition-all duration-200 ease-in"
              >
                FAQ e Assistenza
              </p>
              <p
                onClick={() => handleMenuClick(4, "Prezzi")}
                className="text-[#615E83] font-normal text-[16px] leading-[50px] cursor-pointer px-[23px] hover:bg-slate-50 transition-all duration-200 ease-in"
              >
                Prezzi
              </p>
              {subscriptionStatus.hasPremium && (
                <p
                  onClick={() => handleMenuClick(5, "settings")}
                  className="text-[#615E83] font-normal text-[16px] leading-[50px] cursor-pointer px-[23px] hover:bg-slate-50 transition-all duration-200 ease-in"
                >
                  Gestione Fatturazione
                </p>
              )}
            </div>
          </FilterDropdown>
        </div>

        <div className="max-w-[1550px] mx-auto flex items-start  xl:space-x-[35px] h-full">
          {/* desktop tab  */}
          <div className="hidden xl:inline-flex w-[53%] h-full  flex-col space-y-[30px]">
            {filteredMenuList.map(
              ({ id, Icon, title, subtitle, LastIcon }, index) => (
                <div
                  onClick={() => handleMenuClick(id)}
                  key={id}
                  className={`${
                    selectedComponent === id
                      ? "settings-menu-shadow-active"
                      : ""
                  } transition-all duration-300 ease-in-out cursor-pointer rounded-[10px] bg-white h-[93px] flex items-center justify-between pl-[20px] pr-[33px]`}
                >
                  <div className="flex items-center space-x-4">
                    <div className="w-[53px] h-[53px] rounded-[10px] flex items-center justify-center bg-[#1DA1F21A]">
                      <Icon
                        stroke={
                          selectedComponent === id ? "#1DA1F2" : "#525866"
                        }
                        fill={
                          id !== 5
                            ? selectedComponent === id
                              ? "#1DA1F2"
                              : "#525866"
                            : "transparent"
                        }
                      />
                    </div>
                    <div>
                      <h2
                        className={`${
                          selectedComponent === id
                            ? "text-primary"
                            : "text-[#525866]"
                        } font-bold text-[24px]`}
                      >
                        {title}
                      </h2>
                      <p className="text-[14px] font-normal leading-[1.2] text-[#373C47]">
                        {id === 4 && subscriptionStatus.hasPremium
                          ? "Visualizza il tuo piano attuale"
                          : subtitle}
                      </p>
                    </div>
                  </div>
                  <LastIcon
                    className={
                      selectedComponent === id
                        ? id === 3 // if selection equal id 3
                          ? "stroke-primary"
                          : "fill-primary"
                        : id !== 3 // if selection not equal to id 3
                        ? "fill-[#525866]"
                        : "stroke-[#525866]"
                    }
                  />
                </div>
              )
            )}
          </div>
          <div className="w-full xl:w-[47%] h-full  transition-all duration-500 ease-in-out">
            {selectedComponent === 1 && <Profile />}
            {selectedComponent === 2 && <FAQ />}
            {selectedComponent === 4 && <Prices />}
          </div>
        </div>
      </div>
      {loading.isManagingSubscription && (
        <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="animate-spin rounded-full h-20 w-20 border-b-[3px] border-gray-300"></div>
        </div>
      )}
    </AppLayout>
  );
};

export default Settings;
